import * as TYPE from './types';

export const initialState = {
	error: '',
	items: [],
	isLoading: false,
	redirectTo: '',
};

export default (action, state = initialState) => {
	switch (action.type) {
		case TYPE.LOADING:
			return {
				...state,
				isLoading: true,
				error: '',
				redirectTo: '',
			};
		case TYPE.ERROR:
			return {
				...state,
				isLoading: false,
				error: action.payload,
			};
		case TYPE.GET:
			return {
				...state,
				isLoading: false,
				items: action.payload,
			};
		case TYPE.ADD:
			return {
				...state,
				// items: [action.payload.item, ...state.items],
				redirectTo: action.payload.redirectTo,
			};
		case TYPE.TRIGGER:
			return {
				...state,
				isLoading: false,
			};
		default: {
			return state;
		}
	}
};
